import { Grid, Paper } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Table } from '..';
import { DRIVER_STATUS_FILTER } from '../../constants/selects';
import { DRIVER_HEADERS } from '../../constants/table-headers';
import ModalDriver from '../../containers/Drivers/components/Modal';
import useGetDriver from '../../hooks/driver/useGetDriver';
import useGetDrivers from '../../hooks/driver/useGetDrivers';
import useGetRefusedDatas from '../../hooks/driver/useGetRefusedDatas';
import useGetReasonsRefusal from '../../hooks/reasonRefusal/useGetReasonsRefusal';
import { ApplicationState } from '../../store';
import ActivityIndicator from '../ActivityIndicator';
import Pagination from '../atoms/pagination';
import './styles.scss';
import BoxWrapper from '../atoms/boxWrapper';
import ButtonComponent from '../atoms/button';
import FilterIcon from '../../assets/icons/icon-filter.svg';
import InputBase from '@mui/material/InputBase';
import commons from '../../assets/styles/commons';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as SearchIcon } from '../../assets/icons/icon-search.svg';
import SelectCustom from '../atoms/selectCustom';
import DateRangerCustom from '../atoms/dateRangerCustom';
import ItemsPerPageSelect from '../atoms/itemsPerPageSelect';
import { addDays, format } from 'date-fns';
import { DriverTypeEnum } from '../../store/ducks/freight/types';

const TableDrivers: React.FC = () => {
  const { execute, loading } = useGetDrivers();
  const { execute: getDriver, loading: getDriverLoading } = useGetDriver();
  const { execute: getRefusedDatas, loading: getRefusedDatasLoading } =
    useGetRefusedDatas();
  const { execute: getReasonsRefusal, loading: getReasonsLoading } =
    useGetReasonsRefusal();
  const [username, setUsername] = useState<string>('');
  const [status, setStatus] = useState('Todos');
  const [openModal, setOpenModal] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [menuOpen, setMenuOpen] = useState(false);
  const [period, setPeriod] = useState<{ startDate?: Date; endDate?: Date }>({
    startDate: undefined,
    endDate: undefined,
  });

  const { rows, totalRecords } = useSelector(
    (state: ApplicationState) => state.tables.drivers,
  );
  const [drivers, setDrivers] = useState<any>({
    rows: [],
    totalRecords: 0,
    page: 1,
  });
  const [selectedDriverId, setSelectedDriverId] = useState<string | undefined>(
    undefined,
  );
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  const handleClick = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const loadDrivers = async () => {
      const result = await execute({
        page: currentPage,
        status,
        type: DriverTypeEnum.AUTONOMOUS,
        username,
        rowsPerPage,
        startDate: period.startDate && format(period.startDate, 'yyyy/MM/dd'),
        endDate: period.endDate && format(period.endDate, 'yyyy/MM/dd'),
      });
      setDrivers(result);
    };

    loadDrivers();
  }, [currentPage, status, username, rowsPerPage, period]);

  const handleFiltersFreight = async () => {
    setIsDatePickerOpen(false);

    const result = await execute({
      page: currentPage,
      status,
      username,
      rowsPerPage: rowsPerPage,
      startDate: period.startDate && format(period.startDate, 'yyyy/MM/dd'),
      endDate: period.endDate && format(period.endDate, 'yyyy/MM/dd'),
    });
    setDrivers(result);
  };

  const handleOpenModal = async (id: string, status?: string) => {
    if (status) {
      await Promise.all([
        getDriver(id),
        getRefusedDatas(id),
        getReasonsRefusal({ page: 1, rowsPerPage: 100 }),
      ]);

      setSelectedDriverId(id);
      setOpenModal(true);
    }
  };

  if (
    loading ||
    getDriverLoading ||
    getRefusedDatasLoading ||
    getReasonsLoading
  ) {
    return <ActivityIndicator />;
  }

  return (
    <BoxWrapper>
      <ModalDriver
        driverId={selectedDriverId as string}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />

      <Grid container alignContent="stretch" spacing={2}>
        <Grid item xs="auto">
          <ButtonComponent theme="primary" onClick={handleClick}>
            <img src={FilterIcon} alt="Filter" className="icon" />
            Filtrar
          </ButtonComponent>
        </Grid>

        <Grid item style={{ flex: 1 }}>
          <Paper
            component="form"
            elevation={0}
            style={{
              display: 'flex',
              alignItems: 'center',
              height: '40px',
              border: '1px solid #FF7206',
              backgroundColor: '#F7F9FC',
            }}
          >
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                fontFamily: commons.fontFamily,
              }}
              type="text"
              placeholder="Buscar nome do motorista"
              onChange={event => {
                setUsername(event.target.value);
              }}
              className="input-filter"
              value={username}
              inputProps={{ maxLength: 40 }}
            />
            <IconButton
              type="button"
              aria-label="Pesquisar"
              style={{ marginRight: 10 }}
              onClick={() => handleFiltersFreight()}
            >
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid>
      </Grid>

      {menuOpen && (
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={4}>
            <DateRangerCustom
              label={'Período'}
              value={period}
              onChange={newPeriod => setPeriod(newPeriod)}
              isPickerOpen={isDatePickerOpen}
              setIsPickerOpen={setIsDatePickerOpen}
            />
          </Grid>
          <Grid item xs={6}>
            <SelectCustom
              value={status}
              label="Status"
              size="small"
              defaultValue="Selecione um status"
              onChange={event => setStatus(event.target.value as string)}
              options={Object.values(DRIVER_STATUS_FILTER).map(status => ({
                value: status.value,
                label: status.name,
              }))}
            />
          </Grid>
          <Grid item xs={2}>
            <ButtonComponent
              theme="primary"
              mt={6}
              justifyContent="none"
              onClick={handleFiltersFreight}
            >
              Aplicar filtro
            </ButtonComponent>
          </Grid>
        </Grid>
      )}

      <hr />

      <Table
        columns={DRIVER_HEADERS}
        data={rows}
        onViewClick={(id: string, status?: string) =>
          handleOpenModal(id, status)
        }
        notShowInput
      />

      <Grid container justifyContent="space-between">
        <Grid item>
          <ItemsPerPageSelect
            label={'Mostrar'}
            value={rowsPerPage}
            onChange={setRowsPerPage}
          />
        </Grid>
        <Grid item>
          <Pagination
            totalRecords={totalRecords}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            rowsPerPage={rowsPerPage}
          />
        </Grid>
      </Grid>
    </BoxWrapper>
  );
};

export default TableDrivers;
